import axios from 'axios';

export interface PackingPhotoPayload {
  readonly orderNumber: string;
  readonly sequence: number;
  readonly jpeg: Blob;
}

/** Rows already stored for this order, plus one. Called when the packing camera opens. */
export async function fetchNextPackingPhotoSequence(orderNumber: string): Promise<number> {
  const response = await axios.get<{ sequence?: unknown }>('/api/packing-log-images/next', {
    params: { orderNumber },
  });
  const sequence = response.data?.sequence;
  if (typeof sequence !== 'number' || !Number.isInteger(sequence) || sequence < 1) {
    throw new Error('Invalid packing photo sequence');
  }
  return sequence;
}

/** Deletes every stored packing photo for this order. Throws if Storj or the row delete fails. */
export async function deletePackingLogImages(orderNumber: string): Promise<void> {
  await axios.delete('/api/packing-log-images', { params: { orderNumber } });
}

/** Uploads a confirmed packing photo. Throws when Storj or the image row fails. */
export async function savePackingPhoto(payload: PackingPhotoPayload): Promise<void> {
  await axios.post('/api/packing-log-images', payload.jpeg, {
    params: { orderNumber: payload.orderNumber, sequence: payload.sequence },
    headers: { 'Content-Type': 'image/jpeg' },
  });
}
